import {h, Component, Fragment} from "preact";
import * as I from "../utils/icons.jsx";


export function BlankSeparator() {
	return <div class="cl-blank-separator h-3 bg-harif-900"></div>;
}

export function MenuRow({children}) {
	return <div class="cl-menu-row flex h-8 items-center justify-between border-b border-b-harifzinc-950 bg-harif-800 pl-8 text-white">
	  {children}
	</div>
}

export function MenuTitleLabel({children}) {
	return <div class="cl-menu-ttl-label text-sm text-custom-orange">{children}</div>
}

export function MenuTitle({children}) {
	return <MenuRow>
	  <MenuTitleLabel>{children}</MenuTitleLabel>
	</MenuRow>
}

export function MenuCollapseBtnHolder({children}) {
	return <div class="cl-menu-coll-btn-holder h-full w-9 border-l border-l-harifzinc-950 flex items-center justify-center">{children}</div>
}

export function MenuTitleCenteredLabel({children}) {
	return <div class="cl-menu-ttl-center-label w-full text-center text-sm text-custom-orange flex items-center justify-center">{children}</div>
}

export function MenuTitleCentered({children}) {
	return <div class="cl-menu-ttl-center flex h-8 items-center border-b border-b-harifzinc-950 bg-harif-800 text-white">
	  <MenuTitleCenteredLabel>{children}</MenuTitleCenteredLabel>
	</div>
}

export function SearchEventBodyContainer({children, ref}) {
	return <div class="cl-srch-evt-body-cont flex h-20 flex-col items-center justify-center border-b border-b-harifzinc-950 bg-harif-800 text-harifzinc-500" ref={ref}>
		{children}
	</div>
}

export function SearchDescContainer({children}) {
	return <div class="cl-srch-desc-cont flex grow items-center px-2 text-center text-sm leading-4">
		{children}
	</div>
}

export function SearchBarContainer({children}) {
	return <div class="cl-srch-bar-cont h-7 w-full flex-none p-2 pt-0">{children}</div>
}

export function SearchInput({children}) {
	return <div class="cl-srch-input h-full w-full border border-harifzinc-950 bg-harif-900 relative flex items-center justify-center">{children}</div>
}

export function SearchContentWrapper({children, ref, parentRect}) {
	return <div class="cl-srch-cont-wrap fixed overflow-hidden pt-1 pl-1 w-96 z-50" style={`left:${parentRect.left}px;top:${parentRect.top+parentRect.height}px`} ref={ref}>
		{children}
	</div>
}
export function SearchPopupEventsHolder({children}) {
	return <div class="cl-srch-popup-evt-hold h-52 overflow-y-auto scrollbar-fancy">{children}</div>
}

export function SearchEvent() {
	return <div>
		<MenuTitle>Search Event</MenuTitle>
		<SearchEventBodyContainer>
		  <SearchDescContainer>Insert the events name or at least one team in the form below</SearchDescContainer>
		  <SearchBarContainer><SearchInput /></SearchBarContainer>
		</SearchEventBodyContainer>
	</div>
}

export function TimeFilterButtonContainer({children}) {
	return <div class="cl-tmflt-btn-cont flex h-5 justify-between border-b border-b-harifzinc-950 bg-harif-800 text-white">{children}</div>;
}

export function TimeFilterButton({children, onClick, active = false}) {
	return active ? <div class="cl-tmflt-btn w-1/6 border-b-2 border-r border-b-custom-orange border-r-harifzinc-950 bg-harif-800 text-center text-xs text-white cursor-pointer">{children}</div>
		  : <div onClick={onClick} class="cl-tmflt-btn w-1/6 border-b-2 border-r border-b-transparent border-r-harifzinc-950 bg-harif-900 text-center text-xs text-white cursor-pointer hover:border-b-custom-orange hover:bg-harif-800">{children}</div>
}

export function TimeFilter() {
	return <div>
		<MenuTitle>Quick Filter</MenuTitle>
		<TimeFilterButtonContainer>
		  <TimeFilterButton active={true}>All</TimeFilterButton>
		  <TimeFilterButton>All</TimeFilterButton>
		  <TimeFilterButton>All</TimeFilterButton>
		  <TimeFilterButton>All</TimeFilterButton>
		  <TimeFilterButton>All</TimeFilterButton>
		  <TimeFilterButton>All</TimeFilterButton>
		</TimeFilterButtonContainer>
	</div>
}

export function CircleSeparator() {
	return <div class="cl-circle-sep flex w-6 flex-none items-center justify-center"><div class="h-1.5 w-1.5 rounded-full bg-white"></div></div>;
}
export function CircleSeparatorW2() {
	return <div class="cl-circle-sep-w2 flex w-9 flex-none items-center justify-center pl-3"><div class="h-1.5 w-1.5 rounded-full bg-white"></div></div>;
}
export function SportFlagIcon({sport}) {
	return <div class="cl-sportflag-icon relative w-8 p-1">{sport && <span class={"sporticon sp_"+sport.id.replace('/sport/', '')}></span>}</div>;
}
export function RegionFlag({category}) {
	return <div class="cl-regionflag-icon flex w-12 items-center justify-center">
		{category && <RegionFlagIcon category={category} />}
	</div>;
}
export function RegionFlagSmall({category}) {
	return <div class="cl-regionflag-icon-sm flex w-8 items-center justify-center">
		{category && <RegionFlagIcon category={category} />}
	</div>;
}
export function RegionFlagIcon({category}) {
	return <span class={"cl-regionflag-icon rectangleFlag rectangleFlags_"+category.label.toLowerCase().replace(/ /g, '')}></span>
}
export function LeagueFlagIcon({category, tournament}) {
	return <div class={"cl-leagueflag-icon league-"+(category.label+tournament.label).toLowerCase().replace(/ /g, '')} style="width:22px;height:22px"></div>
}
export function TournamentFlagIcon({category, tournament}) {
	return <div class="cl-tournamentflag-icon w-12 flex justify-end">{(category && tournament) && <LeagueFlagIcon category={category} tournament={tournament} />}</div>;
}
export function LeagueNameLabel({children}) {
	return <div class="cl-league-name-lbl w-full min-w-0 grow truncate text-sm">{children}</div>
}

export function TopLeagueButton({children, onClick}) {

	return <div class="cl-topleague-btn flex h-8 items-center bg-harif-800 text-white" onClick={onClick}>
		{children}
	</div>
}

export function TopLeagues() {
	return <div>
		<MenuTitleCentered>Top Leagues</MenuTitleCentered>
		<div>
		  <TopLeagueButton>
			<TournamentFlagIcon />
		    <CircleSeparator />
			<LeagueNameLabel>League Name</LeagueNameLabel>
			<SportFlagIcon />
		  </TopLeagueButton>
		  <TopLeagueButton>
			<TournamentFlagIcon />
		    <CircleSeparator />
			<LeagueNameLabel>League Name</LeagueNameLabel>
			<SportFlagIcon />
		  </TopLeagueButton>
		  <TopLeagueButton>
			<TournamentFlagIcon />
		    <CircleSeparator />
			<LeagueNameLabel>League Name</LeagueNameLabel>
			<SportFlagIcon />
		  </TopLeagueButton>
		</div>
	</div>
}



export function SportButton({children, active = false, onClick}) {
	return !active
		? <div class="cl-sport-btn flex h-8 items-center border-b border-t border-b-harifzinc-950 border-t-harifzinc-700 bg-harif-800 text-white hover:bg-harif-900" onClick={onClick}>{children}</div>
		: <div class="cl-sport-btn flex h-8 items-center border-b border-t border-b-harifzinc-950 border-t-harifzinc-800 bg-harifzinc-900 text-custom-orange hover:bg-harif-900" onClick={onClick}>{children}</div>
}
export function MenuMatchCounter({children}) {
	return <div class="cl-menu-matchount flex w-12 items-center justify-end"><div class="text-xxs border border-harifzinc-950 rounded text-center bg-harif-900 px-1 pb-0.5">{children}</div></div>
}

export function CategoryButton({children, onClick}) {
	return <div class="cl-category-button flex h-8 items-center border-b border-t border-b-harifzinc-950 border-t-harifzinc-800 bg-harifzinc-950 text-white" onClick={onClick}>{children}</div>
}

export function ToggleCartet({active}) {
	return <I.UpArrowIcon class={"h-4 px-2 transition-transform "+(active ? '' : 'rotate-180')} />;
}

export function TournamentButton({children, active, onClick}) {
	return !active ? <div class="cl-tournament-button flex h-8 items-center border-b border-t border-b-harifzinc-950 border-t-harifzinc-800 bg-harifzinc-900 text-white" onClick={onClick}>{children}</div>
		: <div class="cl-tournament-button flex h-8 items-center border-b border-t border-b-harifzinc-950 border-t-harifzinc-800 bg-harifzinc-900 text-custom-orange" onClick={onClick}>{children}</div>
}
export function CircleSeparatorW3({active}) {
	return !active ? <div class="cl-circle-sep-w3 flex w-11 flex-none items-center justify-center pl-5"><div class="h-1.5 w-1.5 rounded-full bg-white"></div></div>
		: <div class="cl-circle-sep-w3 flex w-11 flex-none items-center justify-center pl-5"><div class="h-1.5 w-1.5 rounded-full bg-custom-orange"></div></div>;
}
export function TournamentLabel({children}) {
	return <div class="cl-tournament-lbl w-full min-w-0 grow truncate pb-0.5 pl-1 text-xs">{children}</div>
}
export function TournamentPlusSign({children}) {
	return <div class="cl-tournament-plus relative bottom-0.5 w-8 p-1 text-center font-bold">+</div>;
}

export function SecondarySportsMenuTitle({children}) {
	return <div class="cl-sec-sport-menu-ttl flex h-8 items-center border-b border-b-harifzinc-950 bg-harif-800 text-white">
	  <div class="w-full pl-8 text-left text-sm text-custom-orange">{children}</div>
	</div>
}

export function PrematchMenu() {
	return <div>
	  <div>
		  <SportButton>
			<MenuMatchCounter>1000</MenuMatchCounter>
			<CircleSeparator />
			<LeagueNameLabel>Sport Name</LeagueNameLabel>
			<SportFlagIcon />
		  </SportButton>
	  </div>
	  <div>
		<SportButton active={true}>
		  <MenuMatchCounter>1000</MenuMatchCounter>
		  <CircleSeparator />
		  <LeagueNameLabel>Sport Name</LeagueNameLabel>
		  <SportFlagIcon />
		</SportButton>
		<div>
			<div>
			  <CategoryButton>
				<CircleSeparatorW2 />
				<RegionFlag />
				<LeagueNameLabel>Region Name</LeagueNameLabel>
				<ToggleCartet active={true} />
			  </CategoryButton>
			  <div>
				<TournamentButton>
				  <CircleSeparatorW3 />
				  <TournamentLabel>Tournament</TournamentLabel>
				  <TournamentPlusSign />
				</TournamentButton>
				<TournamentButton active={true}>
				  <CircleSeparatorW3 active={true} />
				  <TournamentLabel>Tournament</TournamentLabel>
				  <TournamentPlusSign />
				</TournamentButton>
				<TournamentButton>
				  <CircleSeparatorW3 />
				  <TournamentLabel>Tournament</TournamentLabel>
				  <TournamentPlusSign />
				</TournamentButton>
			  </div>
			</div>
		</div>
	  </div>
	  <SportButton>
		<MenuMatchCounter>1000</MenuMatchCounter>
		<CircleSeparator />
		<LeagueNameLabel>Sport Name</LeagueNameLabel>
		<SportFlagIcon />
	  </SportButton>
	</div>
}

export function EsportsMenu() {
	return <div>
		<SecondarySportsMenuTitle>E-Sports</SecondarySportsMenuTitle>
		<div>
		  <div>
			  <SportButton>
				<MenuMatchCounter>1000</MenuMatchCounter>
				<CircleSeparator />
				<LeagueNameLabel>Sport Name</LeagueNameLabel>
				<SportFlagIcon />
			  </SportButton>
		  </div>
		  <div>
			  <SportButton>
				<MenuMatchCounter>1000</MenuMatchCounter>
				<CircleSeparator />
				<LeagueNameLabel>Sport Name</LeagueNameLabel>
				<SportFlagIcon />
			  </SportButton>
		  </div>
		  <div>
			  <SportButton>
				<MenuMatchCounter>1000</MenuMatchCounter>
				<CircleSeparator />
				<LeagueNameLabel>Sport Name</LeagueNameLabel>
				<SportFlagIcon />
			  </SportButton>
		  </div>
		</div>
	</div>
}


export function BetServicesContent({children}) {
	return <div class="cl-srvces-content flex h-16 items-center justify-around border-b border-b-harifzinc-950 bg-harif-800 text-white">{children}</div>
}
export function BetServicesCell({children, onClick}) {
	return <div class="cl-srvces-cell py-2 text-center text-sm flex flex-col items-center cursor-pointer hover:text-custom-orange" onClick={onClick}>{children}</div>
}
export function BetServicesIcon({children}) {
	return <div class="cl-srvces-icon mx-auto h-6 w-4 border"></div>
}


export function BetServices() {
	return <div>
		<SecondarySportsMenuTitle>Bet Services</SecondarySportsMenuTitle>
		<BetServicesContent>
		  <BetServicesCell>
			<BetServicesIcon />
			<div>Live Score</div>
		  </BetServicesCell>
		  <BetServicesCell>
			<BetServicesIcon />
			<div>Live Score</div>
		  </BetServicesCell>
		  <BetServicesCell>
			<BetServicesIcon />
			<div>Live Score</div>
		  </BetServicesCell>
		</BetServicesContent>
	</div>
}
